import {toggle} from 'opticks/lib/optimizely'
import {useAuthEnabled, UseCognitoType} from '../modules/useCognito'
import {AuthContextType} from '../types/Auth'
import {useAuth} from './AuthProvider'

type PropsType = {
  // TODO: Disabled for enforcing lint, fix if possible
  // eslint-disable-next-line no-undef
  children: JSX.Element
}

const useToggleAuth = () => {
  const auth0Values = useAuth()
  const authEnabled = useAuthEnabled()

  return toggle('f54ef0b3-cognito-auth', auth0Values, {
    authEnabled
  }) as Partial<AuthContextType> | Pick<UseCognitoType, 'authEnabled'>
}

const WithAuthEnabled = ({children}: PropsType) => {
  const {authEnabled} = useToggleAuth()
  return authEnabled ? children : null
}

export default WithAuthEnabled
